// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"f757580d","428":"43a818f4","824":"2095796a","937":"b373266d"}[chunkId] + ".chunk.css";
};